/*
 * Example of the file name: "model-predictions-per-genus/isoscape_timber_Betula_50.csv"
 * @description: Function extracts the model name from the file name and also store the bucket name and file extension
 * @param {string[]} files: Array of file names
 * @returns {ISpeciesModelOption[]}: Array of objects containing the model name, bucket name, file extension and original file name
 * */

export const extractModelInformation = (files: string[]) => {
  const result = [];

  for (const item of files) {
    const splitStr = item.split('/');
    const fileName = splitStr[splitStr.length - 1];

    if (fileName.includes('50')) {
      const splitFileName = fileName.split('.');
      const modelName = splitFileName[0];
      const fileExtension = splitFileName[1];
      const bucketName = splitStr[0];

      const object = {
        label: modelName,
        value: modelName,
        bucketName,
        fileExtension,
        originalFileName: item,
      };

      result.push(object);
    }
  }
  return result;
};

/*
 * @description: Function validates the headers of the uploaded file
 * @param {string[]} reqFields: Array of required fields
 * @param {Map<string, string>} fields: Map of headers and values
 * @returns {string[]}: Array of missing fields
 * */
export const validateHeaders = (reqFields: string[], fields: Map<string, string>) => {
  const missingFields = [] as string[];

  for (const field of reqFields) {
    if (!fields.has(field)) {
      missingFields.push(field);
    }
  }
  return missingFields;
};

const calculateFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
};

export const generateLabelString = (item: any) => {
  const { isLatest, lastModified, size } = item;

  const parseDate = new Date(lastModified).toLocaleString();
  const fileSize = calculateFileSize(size);
  const isCurrent = isLatest ? 'Current' : 'Previous';

  return `Date: "${parseDate}" - size: "${fileSize}" - "${isCurrent}"`;
};
